import Product from './Product.js';
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";

export default function ProductCategory(props) {
    const products = props.data.products.map(item => {
        return (
            <Product 
                key={item.productId} 
                data={item} 
                handleProductMenuClick={props.handleProductMenuClick} 
                productCategoryId={props.data.productCategoryId}
            />
        )
    })

    // === begin: Bulk Pricing ===
    let productCategoryDesc;
    if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
        productCategoryDesc = <div>{props.data.productCategoryDescription}</div>;
    } else {
        productCategoryDesc = <></>;
    }
    // === end: Bulk Pricing ===

    return (
        <div id={`prodcat${props.data.productCategoryId}`} className="row mt-4 mb-5">
            {props.data.productCategoryName ? 
            <><span className="h5" data-prodcategoryid={props.data.productCategoryId}>{props.data.productCategoryName}</span>
            {productCategoryDesc}
            </> : <span>Empty</span>}
            {products}                       
        </div>
    )
}